import $ from "jquery"; 
import { CookieService } from './Services/CookieService';
import constants from './constants';

export class CookieDisclaimer {

    constructor() {
        this.hasTakenCookieActionCookie = new CookieService(constants.COOKIES.ACTION_COOKIE);
        this.$cookieDisclaimer = $(".cookie-disclaimer");
        this.init();
    }

    init() {
        if (!this.hasTakenCookieActionCookie.cookieExists()) {
            this.showCookieDisclaimer();
        }
    }

    showCookieDisclaimer() {
        this.$cookieDisclaimer.addClass('active');
    }
}



// WEBPACK FOOTER //
// ./www/wp-content/themes/lynx-hedge/assets/scripts/src/App/CookieDisclaimer.js